"use client";
import { ProfileHeader } from "../components/ProfileHeader";
import { MetricsGrid } from "../components/MetricsGrid";
import { WorkExperience } from "../components/WorkExperince";
import { TechnicalSkills } from "../components/TechnicalSkills";
import { Education } from "../components/Education";

import { useLocation } from "react-router-dom";

export const CandidateProfile = () => {
  const location = useLocation();
  const candidate = location.state?.candidate;

  return (
    <section className="flex w-full bg-gray-50 min-h-[screen]">
      <div className="flex pt-2 mx-auto w-full max-w-[1180px]">
        <div className="flex flex-col gap-8 px-0 pt-8 pb-12 w-full rounded-[40px_0px_0px_0px]">
          <div className="flex flex-col gap-6">
            <ProfileHeader candidate={candidate} />
          </div>
          <div className="flex flex-col gap-6">
            <MetricsGrid />
          </div>
      <div className="flex flex-col gap-6">
         <TechnicalSkills />
            <WorkExperience />
           
          </div>
          <div className="flex gap-6 items-start">
            <Education />
          </div>
        </div>
      </div>
    </section>
  );
};
